// extracted by mini-css-extract-plugin
module.exports = {"container":"Style_container__f11K9","icon":"Style_icon__2eOwb","title":"Style_title__1btJn","description":"Style_description__3gvc7"};